"use client";

import Image from "next/image";

const team = [
  { name: "Jacob Prak", role: "President", image: "/aboutus/jacob.webp" },
  {
    name: "Andy Lamb",
    role: "VP of Supply Chain",
    image: "/aboutus/andy.webp",
  },
  {
    name: "Brian Mitchell",
    role: "Sales Manager (Southeast)",
    image: "/aboutus/brian.webp",
  },
  {
    name: "Elliott Reilly",
    role: "Sales Manager (Northeast)",
    image: "/aboutus/elliott.webp",
  },
  {
    name: "Connor Lamb",
    role: "Sales Manager (Midwest)",
    image: "/aboutus/connor.webp",
  },
  {
    name: "Ross Rankin",
    role: "Sales Manager (Southwest)",
    image: "/aboutus/ross.webp",
  },
  {
    name: "Negar DiPietro",
    role: "Operations Manager",
    image: "/aboutus/negar.webp",
  },
  {
    name: "Justin Hull",
    role: "Information Systems Manager",
    image: "/aboutus/justin.webp",
  },
];

export default function TeamGrid() {
  return (
    <section className="w-full px-[3%] lg:px-[5%] -mt-6 md:-mt-8">
      <div className="mx-auto max-w-[1200px]">
        {/* Heading */}
        <div className="text-center">
          <h3 className="text-[18px] sm:text-[20px] md:text-3xl leading-tight">
            Meet our team
          </h3>
          <div className="mx-auto mt-2 h-[3px] w-[60px] md:w-24 rounded-full bg-[#F4B400]" />
        </div>

        {/* Team Grid */}
        <div className="mt-6 md:mt-8 grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
          {team.map((m, i) => (
            <div key={i} className="text-center">
              {/* Team Image */}
              <div className="relative aspect-square overflow-hidden rounded-2xl">
                <Image
                  src={m.image}
                  alt={m.name}
                  fill
                  className="object-cover"
                  sizes="(max-width: 768px) 33vw, (max-width: 1024px) 25vw, 200px"
                  priority={i < 3}
                />
              </div>

              {/* Name & Role */}
              <div className="mt-2 md:mt-3 leading-tight">
                <div className="text-[12px] sm:text-[13px] md:text-base font-semibold text-black">
                  {m.name}
                </div>
                <div className="text-[11px] sm:text-[12px] md:text-sm text-black/60">
                  {m.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
